import * as React from 'react';
import { ILocation } from '../../../../../types/location';
import { ArticleParagraph1 } from '@cian/ui-kit';
import * as styles from './styles.css';

export interface IRegionsListMobileProps {
  locations: ILocation[];

  onLocationSelect(location: ILocation): void;
}

export const RegionsListMobile: React.FC<IRegionsListMobileProps> = props => {
  const { locations, onLocationSelect } = props;

  return (
    <div className={styles['container']}>
      {locations.map(location => (
        <div key={location.id} className={styles['item']} onClick={() => onLocationSelect(location)}>
          <ArticleParagraph1>{location.displayName}</ArticleParagraph1>
        </div>
      ))}
    </div>
  );
};

RegionsListMobile.displayName = 'RegionsListMobile';
